import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs, query, orderBy, limit, startAfter } from 'firebase/firestore';
import { db } from '../../firebase';
import PaginatedTable from '../PaginatedTable';
import { IconPickerItem } from '../Form/IconField';
import Spinner from '../Spinner';

export default function UserGroupsList({ organizationId }) {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const [opts, setOpts] = useState({
    itemsPerPage: 10,
    sortBy: 'id',
    sortOrder: 'asc',
    persistent: true,
    uid: 'user-groups-list'
  });

  const columns = [
    {
      name: 'ID',
      sortKey: 'id',
      render: (item) => item.id
    },
    {
      name: 'Name',
      sortKey: 'name',
      render: (item) => item.name
    },
    {
      name: 'Icon',
      render: (item) => (
        <IconPickerItem icon={item.icon} size={24} color={item.color} />
      )
    }
  ];

  useEffect(() => {
    const fetchUserGroups = async () => {
      setLoading(true);
      try {
        const path = `organizations/${organizationId}/user-groups`;
        const groupsCollection = collection(db, path);

        let q = query(groupsCollection, orderBy(opts.sortBy, opts.sortOrder), limit(opts.itemsPerPage));

        if (currentPage > 0) {
          const prevDocsSnapshot = await getDocs(
            query(groupsCollection, orderBy(opts.sortBy, opts.sortOrder), limit(currentPage * opts.itemsPerPage))
          );
          const lastVisible = prevDocsSnapshot.docs[prevDocsSnapshot.docs.length - 1];
          q = query(groupsCollection, orderBy(opts.sortBy, opts.sortOrder), startAfter(lastVisible), limit(opts.itemsPerPage));
        }

        const snapshot = await getDocs(q);
        const userGroups = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

        setRows(userGroups);
        setTotalCount((await getDocs(groupsCollection)).size);
      } catch (error) {
        console.error('Error fetching user groups:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserGroups();
  }, [currentPage, opts, organizationId]);

  const setPage = (page) => setCurrentPage(page);
  const setOptions = (newOpts) => {
    setOpts((prev) => ({ ...prev, ...newOpts }));
    setCurrentPage(0); 
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <PaginatedTable
      className="is-fullwidth is-hoverable"
      columns={columns}
      rows={rows}
      currentPage={currentPage}
      totalCount={totalCount}
      loading={loading}
      setPage={setPage}
      opts={opts}
      setOpts={setOptions}
      onRowClick={(item) =>
        navigate(`/user-groups/create?${item.id}?organizationId=${organizationId}`)
      }
    />
  );
}
